import { render } from "./AgencyCustomerData.vue?vue&type=template&id=10a41f82&scoped=true"
import script from "./AgencyCustomerData.vue?vue&type=script&lang=js"
export * from "./AgencyCustomerData.vue?vue&type=script&lang=js"

import "./AgencyCustomerData.vue?vue&type=style&index=0&id=10a41f82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a41f82"]])

export default __exports__